/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import { globalizationService } from '@/services/globalizationService';
import { memo, useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import { EpButton } from '../EpButton';
import EpWrapperQuestion from '../EpWrapperQuestion';

const QuestionFieldArray = () => {
  const { fields }: { fields: any } = useFieldArray({
    name: 'questions',
    shouldUnregister: false,
  });
  const { setValue, getValues } = useFormContext();
  const tag = 'PSNotificationHow';
  const { translations } = globalizationService.getTranslationsByTag(tag);
  const questions = getValues('questions');

  const handleRemove = (index: number) => {
    questions.splice(index, 1);
    setValue('questions', questions);
  };

  useEffect(() => {
    console.info(`🚀 ~ questions:`, questions);
  }, [questions]);

  return (
    <>
      {fields.map((groups: any, index: number) => (
        <div id={`question-${index}`} key={index}>
          {groups && groups.questionId ? (
            <EpWrapperQuestion
              key={groups.questionId}
              QuestionsAnswers={groups}
              index={`${index}`}
            ></EpWrapperQuestion>
          ) : (
            <div
              style={{
                backgroundColor: 'white',
                borderRadius: '4px',
                padding: '10px',
                border: '1px solid #ccc',
              }}
            >
              {Object.values(groups).map((field: any, fieldIndex: number) => {
                if (field && field.questionId !== undefined) {
                  return (
                    <EpWrapperQuestion
                      key={`${field.questionId} ${fieldIndex}`}
                      QuestionsAnswers={field}
                      index={`${index}.${fieldIndex}`}
                    ></EpWrapperQuestion>
                  );
                }
              })}
              {index !== 0 && fields.length > 2 && (
                <EpButton
                  buttonType="danger-outline"
                  buttonSize="sm"
                  buttonAriaLabel={t(translations, 'Delete')}
                  buttonLeftIconName="SolidTrashAlt"
                  buttonIsFullWidth
                  buttonText={t(translations, 'Delete')}
                  buttonOnClickFunc={() => handleRemove(index)}
                />
              )}
            </div>
          )}
        </div>
      ))}
    </>
  );
};

export default memo(QuestionFieldArray);
